// import {Pipe, PipeTransform} from '@angular/core';

// @Pipe({name: 'filterZone'})
// export class FilterZonePipe implements PipeTransform {
//   transform(zones: any[], filtro: string = ''): any[] {
//     if (!filtro.trim()) return zones;
//     return zones.filter(z =>
//       z.hospitals?.some((h: any) =>
//         h.name.toLowerCase().includes(filtro.toLowerCase()),
//       ),
//     );
//   }
// }
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filterZone',
})
export class FilterZonePipe implements PipeTransform {
  transform(cities: any[], filtro: string): any[] {
    if (!cities) return [];
    if (!filtro || filtro.trim() === '') return cities;

    const termo = filtro.toLowerCase().trim();

    return cities.filter(city => {
      // Verifica hospitais diretos (sem zone)
      const hasHospital = city.hospitals?.some((h: any) => h.name?.toLowerCase().includes(termo));

      // Verifica hospitais dentro das zonas
      const hasZone = city.zones?.some((zone: any) =>
        zone.hospitals?.some((h: any) => h.name?.toLowerCase().includes(termo)),
      );

      return hasHospital || hasZone;
    });
  }
}
